(function () {
  var gallery = document.querySelector('[data-mdi-gallery]');
  if (!gallery) return;
  var mainImg  = gallery.querySelector('[data-mdi-gallery-main]');
  var thumbs   = gallery.querySelectorAll('[data-mdi-gallery-thumb]');
  var zoomBtn  = gallery.querySelector('[data-mdi-gallery-zoom]');
  var moreBtn  = gallery.querySelector('[data-mdi-gallery-more]');
  var mainWrap = gallery.querySelector('.mdi-prop__gallery-main');
  var currentIndex = 0;
  var images = Array.prototype.map.call(thumbs, function (t) {
    return { full: t.dataset.full, alt: t.dataset.alt };
  });
  function swapMainImage(src, alt) {
    if (!mainImg) return;
    mainImg.style.opacity = '0';
    setTimeout(function () {
      mainImg.src = src;
      mainImg.alt = alt;
      mainImg.style.opacity = '1';
    }, 180);
  }
  Array.prototype.forEach.call(thumbs, function (thumb, i) {
    thumb.addEventListener('click', function () {
      currentIndex = i;
      swapMainImage(thumb.dataset.full, thumb.dataset.alt);
      Array.prototype.forEach.call(thumbs, function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      var hidden = gallery.querySelectorAll('.mdi-prop__gallery-thumb.is-hidden');
      Array.prototype.forEach.call(hidden, function (t) {
        t.classList.remove('is-hidden');
        t.classList.add('is-revealed');
      });
      moreBtn.style.display = 'none';
    });
  }
  var lb = document.createElement('div');
  lb.className = 'mdi-prop-lightbox';
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-modal', 'true');
  lb.setAttribute('aria-label', 'Photo gallery');
  var lbClose = document.createElement('button');
  lbClose.className = 'mdi-prop-lightbox__close';
  lbClose.setAttribute('aria-label', 'Close gallery');
  lbClose.textContent = '\u00d7';
  var lbPrev = document.createElement('button');
  lbPrev.className = 'mdi-prop-lightbox__nav mdi-prop-lightbox__nav--prev';
  lbPrev.setAttribute('aria-label', 'Previous image');
  lbPrev.textContent = '\u2039';
  var lbNext = document.createElement('button');
  lbNext.className = 'mdi-prop-lightbox__nav mdi-prop-lightbox__nav--next';
  lbNext.setAttribute('aria-label', 'Next image');
  lbNext.textContent = '\u203a';
  var lbImg = document.createElement('img');
  lbImg.className = 'mdi-prop-lightbox__img';
  lbImg.alt = '';
  var lbCounter = document.createElement('p');
  lbCounter.className = 'mdi-prop-lightbox__counter';
  lb.appendChild(lbClose);
  lb.appendChild(lbPrev);
  lb.appendChild(lbImg);
  lb.appendChild(lbNext);
  lb.appendChild(lbCounter);
  document.body.appendChild(lb);
  function setImage(i) {
    currentIndex = (i + images.length) % images.length;
    lbImg.src = images[currentIndex].full;
    lbImg.alt = images[currentIndex].alt;
    lbCounter.textContent = (currentIndex + 1) + ' \u2013 ' + images.length;
    Array.prototype.forEach.call(thumbs, function (t, idx) {
      t.classList.toggle('is-active', idx === currentIndex);
    });
  }
  function openLb(i) {
    setImage(typeof i === 'number' ? i : currentIndex);
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    lbClose.focus();
  }
  function closeLb() {
    lb.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (mainWrap) {
    mainWrap.addEventListener('click', function (e) {
      if (zoomBtn && (e.target === zoomBtn || zoomBtn.contains(e.target))) return;
      openLb(currentIndex);
    });
  }
  if (zoomBtn) {
    zoomBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      openLb(currentIndex);
    });
  }
  lbClose.addEventListener('click', closeLb);
  lbPrev.addEventListener('click',  function () { setImage(currentIndex - 1); });
  lbNext.addEventListener('click',  function () { setImage(currentIndex + 1); });
  lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('is-open')) return;
    if (e.key === 'Escape')      closeLb();
    if (e.key === 'ArrowLeft')   setImage(currentIndex - 1);
    if (e.key === 'ArrowRight')  setImage(currentIndex + 1);
  });
  var tsX = 0;
  lb.addEventListener('touchstart', function (e) { tsX = e.touches[0].clientX; }, { passive: true });
  lb.addEventListener('touchend',   function (e) {
    var dx = e.changedTouches[0].clientX - tsX;
    if (Math.abs(dx) > 50) dx > 0 ? setImage(currentIndex - 1) : setImage(currentIndex + 1);
  }, { passive: true });
})();